//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../no/SelectObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Views",0,"SelectObjectList",0]],[],[]];
SPLM.Drawings.UpdateViewsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.UpdateViewsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;